import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Spinner,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import "react-notification-alert/dist/animate.css";
import jsPDF from "jspdf";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import FSelect from "components/Select/FSelect";
import { CicloService } from "service/CicloService";
import { ReporteService } from "service/ReporteService";
import { AlumnoService } from "service/AlumnoService";

if (pdfFonts && pdfFonts.pdfMake) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts) {
  pdfMake.vfs = pdfFonts.vfs;
}

function ReporteExamenVirtual() {
  const notificationAlertRef = useRef(null);
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tc",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  const [dni, setDni] = useState("");
  const [temporaldto, setTemporalDto] = useState({
    tipociclo: localStorage.getItem("_c") || "",
  });
  const [listExamenes, setListExamenes] = useState([]);
  const [listciclos, setListCiclos] = useState([]);
  const [msjNotFoundData, setMsjNotFoundData] = useState("");
  const [loadingBuscar, setLoadingBuscar] = useState(false);
  const pdfTableRef = useRef(null);

  const cicloService = new CicloService();
  const reporteService = new ReporteService();
  const alumnoService = new AlumnoService();

  useEffect(() => {
    getCiclos();
  }, []);

  const getCiclos = async () => {
    try {
      const response = await cicloService.getCiclos();
      const ciclos = response?.data || [];
      setListCiclos(ciclos);
      
      if (!temporaldto.tipociclo && ciclos.length > 0) {
        setTemporalDto(prev => ({ ...prev, tipociclo: ciclos[0]._id }));
      }
    } catch (error) {
      console.error(error);
      notify("danger", "Error al cargar los ciclos.");
    }
  };

  const getAlumnoDni = async () => {
    if (!dni || dni.length < 8) {
      notify("warning", "Ingrese un DNI válido (8 dígitos).");
      return;
    }

    setLoadingBuscar(true);
    setMsjNotFoundData("");
    setListExamenes([]);
    try {
      // Usar reporteService.getSesionAlumno que busca por nombreusuario (DNI)
      const response = await reporteService.getSesionAlumno(dni);
      const data = response?.data || [];
      
      if (data.length > 0) {
        // En este sistema el alumno id suele estar en data[0].alumno._id o data[0].alumno
        const idAlumno = data[0]?.alumno?._id || data[0]?.alumno;
        if (idAlumno) {
          await getAllExam(idAlumno);
        } else {
          setMsjNotFoundData("No se pudo obtener el ID del alumno.");
          notify("warning", "No se encontró el perfil del alumno.");
        }
      } else {
        setListExamenes([]);
        setMsjNotFoundData("El alumno no está registrado o no tiene acceso.");
        notify("warning", "No se encontraron resultados para el DNI ingresado.");
      }
    } catch (error) {
      console.error(error);
      notify("danger", "Error al consultar el alumno. Verifica el DNI ingresado.");
    } finally {
      setLoadingBuscar(false);
    }
  };

  const getAllExam = async (idAlumno) => {
    try {
      const response = await reporteService.getAllExamAlumno(idAlumno);
      const examenes = response?.data || [];
      const filteredExams = examenes.filter(
        (e) => e.ciclo === temporaldto.tipociclo
      );
      setListExamenes(filteredExams);

      if (filteredExams.length === 0) {
        setMsjNotFoundData("El alumno no tiene exámenes desarrollados en este ciclo.");
        notify("warning", "No se encontraron exámenes para este ciclo.");
      } else {
        notify("success", `Se encontraron ${filteredExams.length} examen(es).`);
      }
    } catch (error) {
      console.error(error);
      notify("danger", "Error al obtener los exámenes del alumno.");
    }
  };

  const generatePDF = (action) => {
    const doc = new jsPDF();
    const html = htmlToPdfmake(pdfTableRef.current.innerHTML);
    const documentDefinition = { content: html };
    const pdfDoc = pdfMake.createPdf(documentDefinition);
    if (action === "download") pdfDoc.download();
    else if (action === "print") pdfDoc.print();
    else pdfDoc.open();
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef} />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="8">
                    <CardTitle tag="h4">Reporte de Exámenes Virtuales</CardTitle>
                  </Col>
                  <Col md="4" className="text-right">
                    <Button
                      color="link"
                      className="btn-icon btn-round"
                      title="Configuración"
                    >
                      <i className="tim-icons icon-settings-gear-63" />
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Zona 2: Barra de filtros */}
                <Row className="align-items-end mb-4">
                  <Col md="5">
                    <FormGroup className="mb-0">
                      <Label for="dni">DNI del Alumno</Label>
                      <Input
                        type="text"
                        id="dni"
                        value={dni}
                        onChange={(e) => setDni(e.target.value)}
                        placeholder="Ingrese DNI"
                        maxLength="8"
                        style={{ height: "40px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="mb-0">
                      <Label for="tipociclo">Ciclo Académico</Label>
                      <FSelect
                        id="tipociclo"
                        name="tipociclo"
                        value={temporaldto.tipociclo}
                        onChange={(e) =>
                          setTemporalDto({
                            ...temporaldto,
                            tipociclo: e.target.value,
                          })
                        }
                        options={listciclos.map((ciclo) => ({
                          value: ciclo._id,
                          label: ciclo.denominacion,
                        }))}
                        placeholder="Seleccione Ciclo"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="1">
                    <FormGroup className="mb-0">
                      <Button
                        color="info"
                        block
                        onClick={getAlumnoDni}
                        disabled={loadingBuscar}
                        style={{ height: "40px", padding: "0" }}
                        title="Consultar"
                      >
                        {loadingBuscar ? (
                          <Spinner size="sm" />
                        ) : (
                          <i className="tim-icons icon-zoom-split" />
                        )}
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Zona 3: Barra de acciones */}
                <Row className="mb-4">
                  <Col md="6">
                    {/* Mensaje si no hay datos */}
                    {!loadingBuscar && listExamenes.length === 0 && msjNotFoundData && (
                      <p className="mb-0 text-muted">{msjNotFoundData}</p>
                    )}
                  </Col>
                  <Col md="6" className="text-right">
                    {listExamenes.length > 0 && (
                      <>
                        <Button
                          color="success"
                          className="btn-fill mr-2"
                          onClick={() => generatePDF("view")}
                        >
                          <i className="tim-icons icon-paper mr-2" />
                          Ver PDF
                        </Button>
                        <Button
                          color="info"
                          className="btn-fill mr-2"
                          onClick={() => generatePDF("download")}
                        >
                          <i className="tim-icons icon-cloud-download-93 mr-2" />
                          Descargar PDF
                        </Button>
                        <Button
                          color="warning"
                          className="btn-fill"
                          onClick={() => generatePDF("print")}
                        >
                          <i className="tim-icons icon-print mr-2" />
                          Imprimir PDF
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>

                <hr className="my-4" />
                {listExamenes.length > 0 && (
                  <div ref={pdfTableRef}>
                    <Table responsive>
                      <thead className="text-primary">
                        <tr>
                          <th>N°</th>
                          <th>Correctas</th>
                          <th>Incorrectas</th>
                          <th>Omitidas</th>
                          <th>Cant. Preguntas</th>
                          <th>Nota</th>
                          <th>Fecha</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listExamenes.map((exam, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{exam.cantidadcorrectas}</td>
                            <td>{exam.cantidadincorrectas}</td>
                            <td>{exam.cantidadomitidas}</td>
                            <td>{exam.cantidadpreguntas}</td>
                            <td>{exam.nota ? exam.nota.toFixed(2) : "0.00"}</td>
                            <td>
                              {exam.fecha ? new Date(exam.fecha).toLocaleString("es-ES") : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ReporteExamenVirtual;
